import { Component, Input } from '@angular/core';
import { CustomerCampaignService } from '../../../../services/customer-campaign.service';

@Component({
  selector: 'app-components-shared-tracking-keyword',
  templateUrl: './tracking-keyword.component.html',
  styleUrls: ['../customer-campaign/customer-campaign.component.scss']
})
export class TrackingKeywordComponent {
  @Input() customer: Boo.Objects.Customer;
  @Input() trackingKeyword: Boo.Objects.WebsiteKeywordTracking;
  @Input() websiteUrls: Boo.Objects.WebsiteUrl[];
  @Input() trackingKeywords: Boo.Objects.WebsiteKeywordTracking[];
  @Input() archivedKeywords: Boo.Objects.ArchivedKeyword[];
  @Input() restrictions: Boo.Objects.CustomerCampaign.Enums.RestrictionTypes[];

  customerCampaignRestrictionTypes_ReadOnly = Boo.Objects.CustomerCampaign.Enums.RestrictionTypes.ReadOnly

  constructor(private customerCampaignService: CustomerCampaignService) { }

  isActiveStatus(websiteUrl: Boo.Objects.WebsiteUrl): boolean {
    return this.customerCampaignService.isActiveStatus(websiteUrl);
  }

  archiveTrackingKeyword(trackingKeyword: Boo.Objects.WebsiteKeywordTracking): void {
    this.customerCampaignService.archiveTrackingKeyword(this.archivedKeywords, this.trackingKeywords, trackingKeyword);
  }

  moveTrackingKeywordToWebsiteUrl(trackingKeyword: Boo.Objects.WebsiteKeywordTracking, websiteUrl: Boo.Objects.WebsiteUrl): void {
    this.customerCampaignService.moveTrackingKeywordToWebsiteUrl(trackingKeyword, websiteUrl);
  }

  get validationMessage(): string {
    if (this.trackingKeyword.IsActive) {
      const keywordPhrases = this.websiteUrls.filter(x => x.StatusId !== Boo.Objects.Enums.WebsiteUrlStatuses.Archived)
        .flatMap(page => page.Keywords)
        .filter(x => x.IsActive)
        .map(x => x.KeywordPhrase.toLowerCase().trim())
        .concat(this.trackingKeywords.filter(x => x.IsActive && x != this.trackingKeyword).map(x => x.KeywordPhrase.toLowerCase().trim()));

      if (keywordPhrases.includes(this.trackingKeyword.KeywordPhrase.toLowerCase().trim())) {
        return 'Duplicate';
      }
    }

    return '';
  }
}
